export const MAPBOX_PARAMS = {
	access_token: process.env.VUE_APP_MAPBOX_TOKEN,
	types: 'locality,place,address',
	country: 'nl,de,fr,be,hu,pl,bg,sk,ro,at,hr,rs,cz,si'
}
